<template>
	<div class="study">
		<van-nav-bar
			title="健康频道"
			left-arrow
			fixed
			class="qjc-nav-bar"
			@click-left="$router.back()"
		/>
		
		<van-list
		  v-model="loading"
		  :finished="finished"
		  finished-text="没有更多了"
		  :offset='50'
		  @load="onLoad"
		>
		  <ul> 
			  <li 
				class="list qjc-clearfix"
				v-for="item in list"
				:key="item.id"
				@click="$router.push('/dayu/m/health/detail/'+item.id)"
			  >
				  <dl class="qjc-fl qjc-texta-l">
					  <dt class="qjc-fts-32 qjc-c-dark qjc-ftw-b">{{ item.title }}</dt>
					  <dd class="qjc-fts-24">
						  <span>
							  <van-image
								width="0.32rem"
								height="0.23rem"
								:src="require('@/assets/images/check_eye.png')"
							  />
							  <span>{{ item.sees }}</span>
						  </span>
					  </dd>
				  </dl>
				  <van-image
					width="1.8rem"
					height="1.35rem"
					class="qjc-fr"
					:src="item.cover.split(',')[0]"
				  />
			  </li>
		  </ul>
		</van-list>
		
	</div>
</template>

<script>
	import Vue from 'vue'
	import { NavBar, Tabbar, TabbarItem, List, Image, Toast } from 'vant'
	Vue.use(NavBar)
	   .use(Tabbar)
	   .use(TabbarItem)
	   .use(List)
	   .use(Image)
	   .use(Toast);
	
	import { getHealthDy } from '@/utils/axios'
	
	export default{
		name: 'dayumHealth',
		data (){
			return {
				page: 1,
				pagesize: 10,
				list: [],
				loading: false,
				finished: false
			}
		},
		methods: {
			onLoad() {
				// 异步更新数据
				setTimeout(() => {
					
					getHealthDy(this.page, this.pagesize).then(res => {
						// console.log(res);
						if(res.errno == 0){
							var page = res.data.pages,
								list = res.data.list;
												
							this.list = this.list.concat(list);
							
							// 加载状态结束
							this.loading = false;
							
							// 数据全部加载完成
							if (this.page >= page) {
							  this.finished = true;
							}else{
								++this.page;
							}
						}else{
							Toast.fail(res.errmsg);
						}
					}, 500);
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.study{
		padding-top: 0.88rem;
		
		.list{
			color: #A1A7B2;
			margin: 0 0.24rem;
			padding: 0.39rem 0;
			border-bottom: 0.01rem solid #DCDEE5;
			
			.van-image{
				vertical-align: middle;
			}
			dl{
				width: 4.9rem;
				
				dt{
					height: 0.88rem;
					line-height: 0.44rem;
					margin-bottom: 0.24rem;
				}
				dd{
					line-height: 0.24rem;
					
					span{
						margin-right: 0.46rem;
						
						span{
							vertical-align: middle;
							margin-left: 0.09rem;
						}
					}
				}
			}
		}
		.van-tabbar{
			height: 0.98rem;
			
			span{
				font-size: 0.2rem;
			}
			img{
				width: 0.43rem;
				height: 0.44rem;
			}
		}
	}
</style>
